import React from 'react';
import Loader from './Loader';
import PropTypes from 'prop-types';


const Loading = (props) => {
  const { title, error } = props;
  if (error) {
    let text = error;
    if (error instanceof Error) {
      text = error.message;
    }
    return <div className="loader-container">{text}</div>
  }

  return (
    <div className="loader-container">
      <Loader />
      <div className="font-weight-bold m-b-15 m-t-10 text-center">{title}</div>
    </div>
  );
}

Loading.propTypes = {
  title: PropTypes.string,
  error: PropTypes.string
};

Loading.defaultProps = {
  error: null,
  title: 'Carregando...'
};

export default Loading;
